import { Decimal } from 'decimal.js'

import { CRYPTO_KEYS, STRING } from 'resources'

import getDecimalValue from './get-decimal-value'

const formatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })
const defaultScale = 8
const cryptoScale = {
  [CRYPTO_KEYS.BITCOIN]: defaultScale,
  [CRYPTO_KEYS.ETHEREUM]: 18,
  [CRYPTO_KEYS.USDC]: 6,
}

/**
 * Converts a crypto amount into a decimal value
 * @param {number|string|Decimal} amount Amount to be converted to a Decimal value
 * @param {number} scale Number of decimal places of scale
 * @returns {Decimal} Decimal value for the crypto amount
 */
export const getCryptoValue = (amount, crypto, scaleOverride) => {
  const decimalValue = getDecimalValue(amount)
  let scale
  if (scaleOverride >= 0) {
    scale = scaleOverride
  } else {
    scale = cryptoScale[crypto] ?? defaultScale
  }
  return decimalValue.toDecimalPlaces(scale, Decimal.ROUND_UP)
}

/**
 * Formats the amount as points based on the `pointsMultiplier`
 * @param {number|string|Decimal} amount The dollar amount to be formatted
 * @param {'bitcoin'|'ethereum'|'usdc'} crypto The crypto currency key
 * @param {boolean} [withTicker=false] Whether the ticker suffix is added
 * @returns {string} formatted Amount
 */
const formatCrypto = (amount, crypto, withTicker = false, scaleOverride = -1) => {
  const scale = scaleOverride >= 0 ? scaleOverride : cryptoScale[crypto] ?? defaultScale

  const cryptoValue = getCryptoValue(amount, crypto, scale)

  const [integerValue, decimalValue] = cryptoValue.toFixed(scale, Decimal.ROUND_UP).split('.')

  const formattedIntegerValue = formatter.format(integerValue)
  const formattedDecimalValue = decimalValue ? decimalValue.replace(/0+$/, '') : ''
  const formattedValue = formattedDecimalValue
    ? `${formattedIntegerValue}.${formattedDecimalValue}`
    : formattedIntegerValue

  if (withTicker) {
    return `${formattedValue} ${STRING.crypto[crypto]?.ticker ?? ''}`
  }

  return formattedValue
}

export default formatCrypto
